import { z } from 'zod';
/**
 * v2 扁平 BOM：一个产品下多张 BOM，每张是一份扁平物料行清单（无层级树）。
 * 由 Excel（S1 Ultra.xls 格式）整表上传。
 */
/** 一条扁平 BOM 行 */
export const BomRowSchema = z.object({
    seq: z.number().int().nonnegative(), // BOM序号；缺失则用解析行号
    part_no: z.string().min(1).max(120), // 子件编号 ⭐
    name: z.string().max(300).default(''), // 物料名称
    spec: z.string().max(1000).default(''), // 规格
    unit: z.string().max(20).default('PCS'), // 单位
    qty: z.number().default(1), // 单位用量（允许小数）
    designator: z.string().max(8000).optional(), // 位号
    change_status: z.string().max(40).optional(), // 状态：增加/修改/空
    ecn_no: z.string().max(120).optional(), // ECN编号（源表文本，仅展示）
    level_label: z.string().max(40).optional(), // 层级（0/.1/..2），仅展示
    note: z.string().max(2000).optional(), // BOM备注
    extra: z.record(z.string(), z.unknown()).optional(), // 其余源列原样保留
});
/** BOM 主档（v2） */
export const BomV2MetaSchema = z.object({
    id: z.string(),
    name: z.string().min(1).max(200),
    code: z.string().max(120).optional(),
    row_count: z.number().int().nonnegative().default(0),
    source_file: z.string().max(300).optional(),
    source_file_s3_key: z.string().max(500).optional(), // 原始上传的 .xls，可下载
    uploaded_at: z.number().int().optional(),
    uploaded_by_user_id: z.string().optional(),
    current_snapshot_key: z.string().optional(),
});
/** 新建 BOM（含整表行）：Excel 解析后提交 */
export const CreateBomV2Schema = z.object({
    name: z.string().trim().min(1).max(200),
    code: z.string().trim().max(120).optional(),
    source_file: z.string().max(300).optional(),
    source_file_s3_key: z.string().max(500).optional(),
    rows: z.array(BomRowSchema).min(1).max(5000),
    notify: z.boolean().default(false), // 上传后是否发邮件通知
    notify_subject: z.string().max(200).optional(), // 自定义邮件主题，留空用默认
    notify_body: z.string().max(5000).optional(), // 自定义邮件正文，留空用默认
});
/** 重新上传（整表覆盖）某 BOM 的行 */
export const ReplaceBomRowsSchema = z.object({
    source_file: z.string().max(300).optional(),
    source_file_s3_key: z.string().max(500).optional(),
    rows: z.array(BomRowSchema).min(1).max(5000),
    notify: z.boolean().default(false),
    notify_subject: z.string().max(200).optional(),
    notify_body: z.string().max(5000).optional(),
});
//# sourceMappingURL=bom-v2.js.map